import { z } from 'zod';
import { CANCEL_CAL_EVENT_REASON_MAX_LENGTH } from '../../events/cancel-cal-event-reason-max-length.js';
import { requiredUuidString } from '../zod-helpers/index.js';
export const cancelCalEventInputSchema = z.object({
    eventId: requiredUuidString('Event is required.', 'Invalid event ID.'),
    reason: z
        .string()
        .trim()
        .min(1, 'A reason is required.')
        .max(CANCEL_CAL_EVENT_REASON_MAX_LENGTH, `Reason must be ${CANCEL_CAL_EVENT_REASON_MAX_LENGTH} characters or fewer.`),
});
//# sourceMappingURL=cancel-cal-event-input.js.map